import { Box as BoxUI } from "@mui/material";
import styled from "styled-components";

export const Content = styled(BoxUI)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 1000px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 24px 16px;
`;

export const ActionsContainer = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;

  > button:first-child {
    margin-right: 10px;
  }
`;

export const CantainerButtom = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 22px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 22px;
  margin-bottom: 16px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerStatus = styled.div<{ colorTheme?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 3px 6px;
  height: 24px;
  width: auto;
  gap: 4px;

  border: 1px solid
    ${({ theme, colorTheme }) =>
      colorTheme === "primary"
        ? theme.palette.primary.main
        : theme.palette.secondary.main};
  span {
    line-height: 0;
  }
`;

export const ContainerIdTransition = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
`;
